module.exports = __webpack_public_path__ + "img/ico-arrow-negative.a4600a56.svg";